const PropertyControlledComponent = ({ controllerProperty, children, fallback }) => {
  if (!controllerProperty) return fallback

  return children
}

export default PropertyControlledComponent
